/**
 * Created by Teo on 11/09/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('leadCallsAggregated', {
                abstract: true,
                parent: 'app',
                url: '/leadCalls/aggregated',
                data: {
                    authorities: ['ROLE_SYSTEM', 'ROLE_REC_MANAGEMENT', 'ROLE_REC_ADMINISTRATOR', 'ROLE_ADMIN'],
                    pageTitle: 'sigmaCrmApp.prospectivePatients.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/adminIndex/leadCallsAggregated/leadCallsAggregated.html',
                        controller: 'LeadCallsAggregatedController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

    }

})();
